// import { useConfig } from 'ply-config'
import AssignmentIcon from '@mui/icons-material/Assignment'
import { useWebSocket } from 'ply-utils/webSocket/Provider'
import { TaskItem, type TaskProps } from 'ply-ux/Tasks'

export interface BatchPayload {
	metadata?: {
		url: string
		entity: string
		ns?: string
	}
	action: string
	values: any
	//
	ids: string[]
	//
	filters: unknown
	count: number
}

export type BatchTaskProps = TaskProps<BatchPayload>

export function BatchTask({ id, payload, updaters }: BatchTaskProps) {
	// const [config] = useConfig(['foo'])
	const ws = useWebSocket()
	const count = payload.ids ? payload.ids.length : payload.count
	const entity = payload.metadata?.entity

	async function trackProgress({
		ns,
		expectedMessagesCount,
	}: {
		ns: string
		expectedMessagesCount: number
	}) {
		let counter = expectedMessagesCount

		return new Promise<void>((resolve, reject) => {
			const off = ws.on(ns, ({ content, success }: any) => {
				counter--

				const { message, id: entityId } = content ?? {}
				const percent =
					((expectedMessagesCount - counter) / expectedMessagesCount) * 100

				const status = updaters.updateProgress(percent)

				if (success === false) {
					updaters.updateStatus('error', `${entityId} - ${message}`)
				}

				if (counter) {
					return
				}

				off()
				console.log(percent, status)
				if (status === 'success') {
					resolve()
				} else {
					reject(message)
				}
			})
		})
	}

	async function handleInit() {
		const timeout = setTimeout(
			() => {
				updaters.updateStatus(
					'error',
					'The operation seems to be taking too long, there could be a problem.',
				)
			},
			1000 * ((payload.count ?? payload.ids?.length) * 20 || 90),
		)

		try {
			const res = await fetch(
				payload.metadata?.url ?? '', //?? args.defaultUrl,
				{
					method: 'POST',
					credentials: 'include',
					body: JSON.stringify({
						...cleanValues(payload.values),
						action: payload.action,
						ids: normalizeSelection(payload.ids),
						filters: normalizeFilters(payload.filters as any),
					}),
				},
			)

			if (!res.ok) {
				throw Error(`Request failed (${res.statusText})`)
			}

			const {
				sync_token: ns,
				total,
				success = true,
				message,
			} = await res.json()

			if (!success) {
				throw Error(message)
			}

			trackProgress({
				ns,
				expectedMessagesCount:
					total ?? payload.count ?? payload.ids?.length ?? 1,
			}).catch((err) => {
				clearTimeout(timeout)
				updaters.updateStatus('error', err?.message ?? '')
			})
		} catch (e: any) {
			clearTimeout(timeout)
			updaters.updateStatus('error', e?.message ?? e)
		}
	}

	return (
		<TaskItem
			onInit={handleInit}
			id={id}
			icon={<AssignmentIcon />}
			label={` ${entity} bulk update (${count} entit${
				count === 1 ? 'y' : 'ies'
			})`}
		/>
	)
}

function cleanValues(values: any) {
	return Object.entries(values).reduce<any>((acc, [key, value]) => {
		if (value) {
			acc[key] = value
		}

		return acc
	}, {})
}

function normalizeSelection(selection: any) {
	return selection ? selection : undefined
}

function normalizeFilters(filter?: any[]) {
	return filter
		? // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
			filter.reduce((acc, f) => ({ ...acc, [f.name]: f.value }), {})
		: undefined
}
